import { AppRoute } from "@/routes/app-routes.ts";
import education from "@/i18n/definitions/education";

export const kaikkiJarjestajatRoutes = {
  categories: [
    {
      anchor: "KaikkiJarjestajat",
      components: [
        {
          anchor: "Link",
          name: "SitemapLink",
          properties: {
            route: AppRoute.KaikkiJarjestajat,
            text: education.kaikkiKoulutuksenJarjestajat
          }
        }
      ]
    }
  ]
}